export class SalesforceConstants {
    static FieldTypes = {
        Text: [
            'anytype',
            'string',
            'textarea',
            'url',
            'email',
            'phone',
            'picklist',
            'multipicklist',
            'id',
            'reference',
        ],
        Numeric: ['anytype', 'double', 'int', 'long', 'currency', 'percent', 'reference'],
        Date: ['anytype', 'date', 'datetime', 'time'],
        Boolean: ['anytype', 'boolean', 'checkbox'],
    };
}
